import { cn, FilePreview } from "@tellescope/ui";
import { Tooltip } from "@tellescope/design-system";
import { File } from "lucide-react";
import { useTranslation } from "react-i18next";
import { FilePreviewDialog } from "../../../../components/FilePreviewDialog";
import type { ChatAttachment } from "../../../../hooks/useMessagingAttachments";
import { useSecureFileUrl } from "@tellescope/tanstack-query";

export interface InboxAttachmentPreviewProps {
  attachment: ChatAttachment;
  onRemove?: () => void;
  className?: string;
}

const canPreviewFileType = (fileType: string) => {
  const lowerFileType = fileType.toLowerCase();
  return lowerFileType.includes("png") || lowerFileType.includes("jpg") || lowerFileType.includes("jpeg");
};

export const InboxAttachmentPreview = ({ attachment, onRemove, className }: InboxAttachmentPreviewProps) => {
  const { t } = useTranslation("inbox");

  const src = useSecureFileUrl(attachment.secureName);

  const canPreview = src && canPreviewFileType(attachment.type);

  return (
    <FilePreviewDialog secureName={attachment.secureName} fileType={attachment.type} fileName={attachment.name}>
      <FilePreview
        fileName={attachment.name ?? t("Unnamed attachment")}
        fileType={attachment.type}
        onRemove={onRemove}
        className={cn("h-12 w-12", className)}
      >
        {canPreview ? (
          <img src={src} />
        ) : (
          <Tooltip>
            <Tooltip.Trigger asChild>
              <div className="flex h-12 w-12 flex-col items-center justify-center gap-0.5 p-1">
                <File className="text-muted-foreground shrink-0" />
                <p className="w-full truncate text-center text-[10px] leading-tight text-muted-foreground">
                  {attachment.name ?? t("Unnamed attachment")}
                </p>
              </div>
            </Tooltip.Trigger>
            <Tooltip.Content>{attachment.name ?? t("Unnamed attachment")}</Tooltip.Content>
          </Tooltip>
        )}
      </FilePreview>
    </FilePreviewDialog>
  );
};
